import React from 'react';

// Create a context with a default value (optional)
const DataContext = React.createContext<number | null>(null);

export default DataContext;
